export default __webpack_public_path__ + "universal/images/starkiller.35e2d09f02169a11307370ccc8ecdf65.svg";